import { render, staticRenderFns } from "./VisualizacaoGuia.vue?vue&type=template&id=7c54c166&"
import script from "./VisualizacaoGuia.vue?vue&type=script&lang=js&"
export * from "./VisualizacaoGuia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports